module.exports = __webpack_public_path__ + "img/ss2.e3abd956.png";